import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ListItem.scss';

class ListItem extends Component {
  render () {
    return (
      <div className='listItem'>
        <div className='listItem-name'>{this.props.name}</div>
        <div className='listItem-value'>
        {this.props.value}{this.props.hasMore && <i className='iconfont icon-arrrow'></i>}
        </div>
      </div>
    )
  }
}

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  hasMore: PropTypes.bool
}

export default ListItem;